import { RadioButtonAttributeProps } from 'Types/Attribute.types'
import type { RadioChangeEvent } from 'antd/lib'
import { Radio } from 'antd/lib'
import React, { useCallback } from 'react'
import './RadioButton.less'

const RadioButtonAttribute: React.FC<RadioButtonAttributeProps> = props => {
    const handleChange = useCallback(
        ({ target: { value } }: RadioChangeEvent) => {
            props.onChange(value)
        },
        [props]
    )

    return (
        <div
            className={`attribute-main ${props.className}`}
            style={{ width: props.width ?? '90%' }}
            data-testid="radio-wrapper"
        >
            <span className="attribute-main-title">{props.label}</span>
            <Radio.Group
                options={props.options}
                onChange={handleChange}
                value={props.value}
                optionType={props.optionType}
                disabled={props.readonly}
            />
        </div>
    )
}

export default RadioButtonAttribute
